import { FilterValue } from './filter-value.model';

export class Filter {
  readonly Name: string;

  private values: FilterValue[] = [];
  get Values(): FilterValue[] {
    return this.values;
  }

  constructor(name: string, ...values: FilterValue[]) {
    this.Name = name;
    this.values = values;
  }

  removeValue(value: string): void {
    const existingValueIndex = this.Values.findIndex(v => v.Value === value);
    if (existingValueIndex > -1) {
      this.values = [...this.values.slice(0, existingValueIndex), ...this.values.slice(existingValueIndex + 1)];
    }
  }

  clearValues(): void {
    this.values = [];
  }
}
